import { action } from 'satcheljs';

export const showWebPushSuccessCallout = action('showWebPushSuccessCallout');
export const dismissWebPushSuccessCallout = action('dismissWebPushSuccessCallout');
